import { DutyStatusLogService } from "../../../../../model/DutyStatusLogs";
import { DriveStore } from "../../../../../store/reducers";
import { getCurrentVehicle } from "../../../../../utils/device";
import { filterMalfunctions } from "../../../../hos/eldMalfunctions/helpers/malfunctionDataProcessor";
import { ConnectionDialogTranslationsDictionary } from "./ConnectionDialogTranslation";

export interface ConnectionDialogListData {
    vehicleStatus: {};
    networkStatus: {};
    gpsStatus: {};
    malfunctionsStatus: {};
}

export const enum DisplayDetailEnum {
    default = 0,
    vehicleDisconnect = 1,
    network = 2,
    gps = 3,
    malfunctions = 4
}

const loadLogs = (dutyStatusLogService: DutyStatusLogService) => {
    return dutyStatusLogService.getHOSLogs(true, undefined, false, true, true).filter((log) => !log.isPositioningComplianceDiagnosticLog());
};

export function isNoVehicle(store: DriveStore): boolean {
    let vehicle = getCurrentVehicle(store);

    return !vehicle || (vehicle && vehicle.id === "NoDeviceId");
}

export const vehicleStatus = (error: boolean, store: DriveStore) => {
    if (isNoVehicle(store)) {
        return ConnectionDialogTranslationsDictionary.noVehicle;
    }

    return error ? ConnectionDialogTranslationsDictionary.vehicleDisconnected : ConnectionDialogTranslationsDictionary.vehicleConnected;
};

export const networkStatus = (error: boolean) => {
    return error ? ConnectionDialogTranslationsDictionary.geotabDriveDisconnected : ConnectionDialogTranslationsDictionary.geotabDriveConnected;
};

export const gpsStatus = (error: boolean) => {
    return error ? ConnectionDialogTranslationsDictionary.gpsDisconnected : ConnectionDialogTranslationsDictionary.gpsConnected;
};

export const malfunctionsStatus = (error: boolean) => {
    return error ? ConnectionDialogTranslationsDictionary.malfunctions : ConnectionDialogTranslationsDictionary.noMalfunctions;
};

export const getFilteredLogs = (dutyStatusLogService: DutyStatusLogService) => {
    return loadLogs(dutyStatusLogService).filter(filterMalfunctions);
};